import "../styles/features.css";
import { useState } from "react";
import BookDemo from "../components/BookDemo";

export default function FeaturesSection() {
  const [openDemo, setOpenDemo] = useState(false);

  return (
    <>
      <section className="features-wrapper">
        <div className="features-main">
          <span className="features-label">Features</span>

          <h2>
            Here's why <br /> you'll love it
          </h2>

          <div className="features-actions">
            <button
              className="btn primary"
              onClick={() => setOpenDemo(true)}
            >
              GET STARTED
            </button>
          </div>
        </div>

        <div className="features-grid">
          <div className="feature-card">One - one mentorship</div>
          <div className="feature-card">Online / Offline classes</div>
          <div className="feature-card">Hands on experience</div>
          <div className="feature-card">Placement support</div>
        </div>
      </section>

      {/* ✅ MODAL */}
      {openDemo && (
        <BookDemo onClose={() => setOpenDemo(false)} />
      )}
    </>
  );
}
